/**
 * @file: 画布组件初始化操作
 * @author: xiaolong.huang@dmall.com
 */

import * as SketchpadRenderCore from './renderCore/index';
import Config from '../../config/index';

export function init(cube: CubeNode): boolean {
    // 事件绑定
    bindEvent(cube);

    return true;
}

// 事件绑定
function bindEvent(cube: CubeNode): boolean {
    bindLockSelect(cube);

    return true;
}

// 选择规则切换
export function bindLockSelect(cube: CubeNode): void {
    cube.jView.find('.J_lockSelect').on('click', function(e) {
        let $target: JQuery<HTMLElement> = $(e.target);
        let $tab: JQuery<HTMLElement> = $target.closest('li');

        if (!$tab.length) {
            return;
        }
        let index: number = $tab.index();

        Config.set({
            moduleName: 'select',
            key: 'selectType',
            value: index
        });
        SketchpadRenderCore.selectTabSwitch(cube);
    });
}

export default init;
